/** Resolve bilingual CMS field: string | { id, en } */
export function bi(value, lang = "id") {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    return value[lang] || value.id || value.en || "";
  }
  return String(value);
}

export function biSet(current, lang, next) {
  const base =
    current && typeof current === "object" && !Array.isArray(current)
      ? { id: current.id || "", en: current.en || "" }
      : { id: typeof current === "string" ? current : "", en: typeof current === "string" ? current : "" };
  return { ...base, [lang]: next };
}

export function emptyBi(id = "", en = "") {
  return { id, en };
}
